<script>
import { isMobile } from "@js/helpers.ts";

export default {
    name: "OnlyDesktop",
    data() {
        return {
            isMobile: null,
        };
    },
    methods: {
        updateIsMobile() {
            this.isMobile = isMobile();
        },
    },
    mounted() {
        if (typeof window !== "undefined") {
            this.isMobile = isMobile();
            window.addEventListener("resize", this.updateIsMobile);
        }
    },
    beforeDestroy() {
        if (typeof window !== "undefined") {
            window.removeEventListener("resize", this.updateIsMobile);
        }
    },
};
</script>

<template>
    <slot v-if="isMobile !== null && !isMobile" class="w-full" />
</template>

<style scoped lang="scss">
</style>
